import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistReducer } from 'redux-persist';
//import { routerMiddleware } from 'react-router-redux';
import storage from 'redux-persist/lib/storage/session';
import { routerMiddleware } from 'connected-react-router'
import apiClient from '../Api/Index';
import { rootReducers } from '../Reducers/Index';

import { apiMiddleware } from '../../store/middlewares/apiMiddleware';
import { browserHistoryMiddleware } from '../../store/middlewares/browserHistoryMiddleware';
import { pageTitleMiddleware } from '../../store/middlewares/pageTitleMiddleware';
import { metaTagMiddleware } from '../../store/middlewares/metaTagMiddleware';
import { canonicalUrlMiddleware } from '../../store/middlewares/canonicalUrlMiddleware';
import { robotsMiddleware } from '../../store/middlewares/robotsMiddleware';
import { searchRequestMiddleware } from '../../store/middlewares/searchRequestMiddleware';
import { locationChangeMiddleware } from '../../store/middlewares/locationChangeMiddleware';
const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: [
      'filters',
      'content',
      'shortlist',
    ],
};

export const createTheStore = (history) => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const persistedReducer = persistReducer(persistConfig, rootReducers(history));
  return  createStore(persistedReducer, {}, composeEnhancers(
      applyMiddleware(
        thunk,
        apiMiddleware(apiClient),
        canonicalUrlMiddleware(),
        robotsMiddleware(),
        routerMiddleware(history),
        locationChangeMiddleware(),
        browserHistoryMiddleware(history),
        pageTitleMiddleware(),
        metaTagMiddleware(),
        searchRequestMiddleware(),
      ),
    ));
};
